<template>
  <div class="header">
    <div class="img-container"></div>
    <div class="intro">
      <div><SubLink link_style="sub-link" path="/" text="Jiaming Qiu" /></div>
      <p class="intro-font">
        PhD candidate<br />Dept. of Computer Science<br />Washington University
        in St. Louis
      </p>
    </div>
    <div class="buttons">
      <div class="btn home-div">
        <div>
          <SubLink
            class="home-link"
            link_style="sub-link"
            path="/"
            text="Jiaming Qiu"
          />
        </div>
      </div>
      <div class="btn">
        <Button
          :class="divshow[0] ? 'show' : ''"
          @btn-click="toggle"
          text="Navigate"
          :btn_id="0"
        />
        <div
          class="btn-expand"
          :style="{
            height: divshow[0]
              ? this.$refs['ul-0'].clientHeight +
                2 * this.$refs['ul-0'].clientTop +
                'px'
              : '0',
          }"
        >
          <ul class="expand expand-nav" ref="ul-0">
            <li>
              <SubLink
                class="expand-link"
                path="/background"
                text="Background"
              />
            </li>
            <li>
              <SubLink
                class="expand-link"
                path="/publications"
                text="Publications"
              />
            </li>
          </ul>
        </div>
      </div>
      <div class="btn last">
        <Button
          :class="divshow[1] ? 'show' : ''"
          @btn-click="toggle"
          text="Follow"
          :btn_id="1"
        />
        <div
          class="btn-expand"
          :style="{
            height: divshow[1]
              ? this.$refs['ul-1'].clientHeight +
                2 * this.$refs['ul-1'].clientTop +
                'px'
              : '0',
          }"
        >
          <ul class="expand expand-flw" ref="ul-1">
            <li>
              <font-awesome-icon
                class="icon-style"
                :icon="['fas', 'envelope']"
              />
              <Link
                class="link-font"
                path="mailto:qiujiaming@wustl.edu"
                text="Email"
              />
            </li>
            <li>
              <font-awesome-icon class="icon-style" :icon="['fab', 'github']" />
              <Link
                class="link-font"
                path="https://github.com/qiujiaming315"
                text="Github"
              />
            </li>
            <li>
              <font-awesome-icon class="icon-style" :icon="['fas', 'graduation-cap']" />
              <Link
                class="intro-font link-font"
                path="https://scholar.google.com/citations?user=eIkRVZIAAAAJ&hl=en"
                text="Scholar"
              />
            </li>
            <li>
              <font-awesome-icon class="icon-style" :icon="['fab', 'orcid']" />
              <Link
                class="link-font"
                path="https://orcid.org/0000-0001-9576-0499"
                text="ORCID"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubLink from "./SubLink";
import Link from "./Link";
import Button from "./Button";

export default {
  name: "HeaderMobile",
  components: {
    SubLink,
    Link,
    Button,
  },
  data() {
    return {
      divshow: [false, false],
    };
  },
  methods: {
    toggle(id) {
      this.$set(this.divshow, id, !this.divshow[id]);
    },
  },
};
</script>

<style scoped>
div.header {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: left;
  width: 100%;
  height: 120px;
  padding-left: 60px;
  padding-right: 60px;
  background-color: #66ccff;
  box-shadow: rgba(44, 62, 80, 0.3) 0px 2px 6px 0px;
  z-index: 1;
}
div.img-container {
  width: 90px;
  height: 90px;
  margin: auto 0;
  border: 4px solid #cceeff;
  border-radius: 50%;
  background-image: url("https://qiujiaming315.github.io/data/profile_head.jpg");
  background-position: center;
  background-size: cover;
}
div.intro {
  margin: auto 0;
  margin-left: 20px;
}
div.intro > div {
  position: relative;
  display: inline-block;
  height: 27px;
}
div.buttons {
  margin: auto 0;
  margin-left: 20px;
  display: flex;
}
a.home-link {
  font-size: 18px;
}
p.intro-font {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #2c3e50;
  font-size: 15px;
  margin-top: 3px;
  margin-bottom: 0;
  line-height: 120%;
}
div.btn {
  height: 40px;
  width: 100px;
  display: inline;
  margin-right: 20px;
}
div.home-div {
  display: none;
  text-align: center;
}
div.home-div > div {
  height: 100%;
  position: relative;
  display: inline-block;
}
div.last {
  margin-right: 0;
}
div.btn-expand {
  width: 100%;
  position: relative;
  overflow: hidden;
  transition: height 200ms;
  z-index: 1;
}
button.show {
  background-color: #2c3e50;
  color: #cceeff;
  border-radius: 8px 8px 0 0;
}
ul.expand {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  width: 100%;
  margin: 0;
  list-style-type: none;
  background-color: #cceeff;
  border: 3px solid #2c3e50;
}
ul.expand-nav {
  padding: 0;
  text-align: center;
}
ul.expand-flw {
  padding-left: 6px;
}
li {
  position: relative;
  display: inline-block;
  margin-bottom: 6px;
}
a.expand-link {
  font-size: 10px;
}
a.expand-link::before {
  height: 2px;
}
.link-font {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #2c3e50;
  font-size: 12px;
}
.icon-style {
  margin-right: 0.6em;
  font-size: 10px;
  color: #2c3e50;
}
@media (min-width: 1000px) {
  div.header {
    display: none;
  }
}
@media (max-width: 750px) {
  div.buttons {
    display: block;
  }
  div.btn {
    height: 30px;
    display: block;
    margin-right: 0;
    margin-bottom: 10px;
  }
  div.home-div {
    display: none;
  }
  div.last {
    margin-bottom: 0;
  }
  p.intro-font {
    font-size: 13px;
  }
  button {
    border-radius: 6px;
    font-size: 10px;
  }
  button.show {
    border-radius: 6px 6px 0 0;
  }
}
@media (max-width: 600px) {
  div.header {
    padding-left: 30px;
  }
  div.intro {
    display: none;
  }
  div.btn {
    margin: 0 auto;
    margin-bottom: 6px;
  }
  div.last {
    margin-bottom: 0;
  }
  div.home-div {
    height: 25px;
    width: 120px;
    display: block;
  }
}
</style>